module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zM13 25c-1.274 0-2.03-.322-3-1l-4 4H4v-2l4.08-3.58L24 8 6 20a5.952 5.952 0 0 1-.242-1.644C5.758 15.042 23.188 4 26.5 4 28 4 28 4 28 5.5 28 8.812 16.312 25 13 25z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/compose-3.js
// module id = 1086
// module chunks = 14